// src/components/ProductDetailsANT.js
import React from 'react';
import { FaWarehouse, FaShippingFast, FaBolt, FaDoorOpen } from 'react-icons/fa';
import { GiRead, GiReceiveMoney } from 'react-icons/gi';
import { MdSettings, MdLeakAdd, MdNaturePeople } from 'react-icons/md';
import './ProductDetails.css';
import Antenna from '../resorcesfiles/ideak/antenna.jpg'; // Use your provided image path
import Mainmastet from '../masterpage/Mainmastet';

const ProductDetailsANT = () => {
  return (
    <Mainmastet content ={<>
        <div className="product-details-container">
      <h1>Environmental Adaptability, Easy Installation</h1>
      <div className="product-content">
        <div className="product-details">
          <div className="features">
            <div className="feature-item">
              <GiRead size={32} />
              <p>Fast Read & Write</p>
            </div>
            <div className="feature-item">
              <MdSettings size={32} />
              <p>Install and Use Conveniently</p>
            </div>
            <div className="feature-item">
              <MdLeakAdd size={32} />
              <p>Long Read & Write Distance</p>
            </div>
            <div className="feature-item">
              <MdNaturePeople size={32} />
              <p>IP67</p>
            </div>
          </div>
        </div>
        <div className="product-image-container">
          <img src={Antenna} alt="Product Antenna" className="product-image" />
        </div>
      </div>
      <div className="functions-container">
        <h2>Functions</h2>
        <div className="functions">
          <div className="function-item">
            <FaWarehouse size={32} />
            <p>Logistics & Warehouse</p>
          </div>
          <div className="function-item">
            <FaShippingFast size={32} />
            <p>Retail & Garment Industry</p>
          </div>
          <div className="function-item">
            <FaBolt size={32} />
            <p>Electricity</p>
          </div>
          <div className="function-item">
            <FaDoorOpen size={32} />
            <p>Access Control</p>
          </div>
        </div>
      </div>
    </div>

    </>} />
  );
};

export default ProductDetailsANT;
